export function cutApiUrl(apiUrl: string): string {
  apiUrl = apiUrl.replace(/\/+$/, '');
  apiUrl = apiUrl.endsWith('/api/v1') ? apiUrl.substring(0, apiUrl.length - '/api/v1'.length) : apiUrl;
  return apiUrl
}
